import DefaultLayout from './Index.vue'

DefaultLayout.install = function(Vue) {
    Vue.component(DefaultLayout.name, DefaultLayout)
}

export default DefaultLayout
